import { render, staticRenderFns } from "./ListSelector.vue?vue&type=template&id=38a772c8&scoped=true"
import script from "./ListSelector.vue?vue&type=script&lang=js"
export * from "./ListSelector.vue?vue&type=script&lang=js"
import style0 from "./ListSelector.vue?vue&type=style&index=0&id=38a772c8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a772c8",
  null
  
)

export default component.exports